import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MainComponent } from './pages/main/main.component';
import { AuthGuard } from './utils/guards/auth.guard';
import { DashboardComponent } from './views/dashboard/dashboard.component';
import { LoginComponent } from './pages/login/login.component';
import { LoginSystemComponent } from './pages/login-system/login-system.component';
import { NonAuthGuard } from './utils/guards/non-auth.guard';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BaoCaoTongHopThuChiComponent } from './pages/bao-cao-tong-hop-thu-chi/bao-cao-tong-hop-thu-chi.component';
import { HoSoHSSVComponent } from './pages/ho-so-hssv/ho-so-hssv.component';
import { HocTapRenLuyenComponent } from './pages/hoc-tap-ren-luyen/hoc-tap-ren-luyen.component';
import { QD5363Component } from './pages/qd5363/qd5363.component';
import { QuaTrinhKhenThuongComponent } from './pages/qua-trinh-khen-thuong/qua-trinh-khen-thuong.component';
import { QuaTrinhKyLuatComponent } from './pages/qua-trinh-ky-luat/qua-trinh-ky-luat.component';
import { ThoiHocNgungHocComponent } from './pages/thoi-hoc-ngung-hoc/thoi-hoc-ngung-hoc.component';
import { ThongTinHocPhiLePhiComponent } from './pages/thong-tin-hoc-phi-le-phi/thong-tin-hoc-phi-le-phi.component';
import { TimKiemDonGianComponent } from './pages/tim-kiem-don-gian/tim-kiem-don-gian.component';
import { TimKiemNangCaoComponent } from './pages/tim-kiem-nang-cao/tim-kiem-nang-cao.component';
import { TongHopNoHocPhiKinhPhiComponent } from './pages/tong-hop-no-hoc-phi-kinh-phi/tong-hop-no-hoc-phi-kinh-phi.component';
import { TongHopNoPhiLePhiComponent } from './pages/tong-hop-no-phi-le-phi/tong-hop-no-phi-le-phi.component';
import { TongHopThiLaiHocLaiComponent } from './pages/tong-hop-thi-lai-hoc-lai/tong-hop-thi-lai-hoc-lai.component';
import { XepLoaiDiemHocPhanComponent } from './pages/xep-loai-diem-hoc-phan/xep-loai-diem-hoc-phan.component';
import { XepLoaiHocKyNamHocComponent } from './pages/xep-loai-hoc-ky-nam-hoc/xep-loai-hoc-ky-nam-hoc.component';
import { TimeTableDetailComponent } from './components/time-table-detail/time-table-detail.component';
import { TraCuuCongViecGiangDayComponent } from './pages/tra-cuu-cong-viec-giang-day/tra-cuu-cong-viec-giang-day.component';
import { ThongKeNhapHocComponent } from './pages/thong-ke-nhap-hoc/thong-ke-nhap-hoc.component';
import { ThongKeNhapHocMasterComponent } from './pages/thong-ke-nhap-hoc-master/thong-ke-nhap-hoc-master.component';
import { NoteBookClassComponent } from './pages/note-book-class/note-book-class.component';
import { NotebookComponent } from './pages/notebook/notebook.component';
import { TraCuuNhanXetGiangDayComponent } from './pages/tra-cuu-nhan-xet-giang-day/tra-cuu-nhan-xet-giang-day.component';
import { TraCuuNhanXetChiTietComponent } from './pages/tra-cuu-nhan-xet-chi-tiet/tra-cuu-nhan-xet-chi-tiet.component';


const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard],
    children: [
    
      {
        path: '',
        component: DashboardComponent,
      },
      {
        path: 'BaoCaoTongHopThuChi',
        component: BaoCaoTongHopThuChiComponent,
      },
      {
        path: 'HoSoHocSinhSinhVien',
        component: HoSoHSSVComponent,
      },
      {
        path: 'HocTapRenLuyen',
        component: HocTapRenLuyenComponent,
      },
      {
        path: 'ThongKeTheoQD5363',
        component: QD5363Component,
      },
      {
        path: 'QuaTrinhKhenThuong',
        component: QuaTrinhKhenThuongComponent,
      },
      {
        path: 'QuaTrinhKyLuat',
        component: QuaTrinhKyLuatComponent,
      },
      {
        path: 'ThoiHocNgungHoc',
        component: ThoiHocNgungHocComponent,
      },
      {
        path: 'ThongTinHocPhiLePhi',
        component: ThongTinHocPhiLePhiComponent,
      },
      {
        path: 'TimKiemDonGian',
        component: TimKiemDonGianComponent,
      },
      {
        path: 'TimKiemNangCao',
        component: TimKiemNangCaoComponent,
      },
      {
        path: 'TongHopNoHocPhiKinhPhi',
        component: TongHopNoHocPhiKinhPhiComponent,
      },
      {
        path: 'TongHopNoPhiLePhi',
        component: TongHopNoPhiLePhiComponent,
      },
      {
        path: 'TongHopThiLaiHocLai',
        component: TongHopThiLaiHocLaiComponent,
      },
      {
        path: 'XepLoaiDiemHocPhan',
        component: XepLoaiDiemHocPhanComponent,
      },
      {
        path: 'XepLoaiHocKyNamHoc',
        component: XepLoaiHocKyNamHocComponent,
      },
      {
        path: 'ThongTinHocPhiLePhi',
        component: ThongTinHocPhiLePhiComponent,
      },
      {
        path: 'BaoCaoTongHopThuChi',
        component: BaoCaoTongHopThuChiComponent,
      },
      {
        path: 'TraCuuCongViecGiangDay',
        component: TraCuuCongViecGiangDayComponent,
      },
      {
        path: 'note-book-class',
        component: NoteBookClassComponent,
      },
      {
        path: 'notebook',
        component: NotebookComponent
      },
      {
        path: 'TraCuuNhanXetGiangDay',
        component: TraCuuNhanXetGiangDayComponent
      },
      {
        path: 'TraCuuNhanXetChiTiet',
        component: TraCuuNhanXetChiTietComponent
      },
    ],
  },
  {
    path: 'login-system',
    component: LoginSystemComponent,
    canActivate: [NonAuthGuard],
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [NonAuthGuard],
  },
  {
    path: 'time-table-detail/:code',
    component: TimeTableDetailComponent,
    canActivate: [NonAuthGuard],
  },
  {
    path: 'thong-ke-nhap-hoc',
    component: ThongKeNhapHocMasterComponent,
    canActivate: [NonAuthGuard],
  },
  // { path: 'time-table-detail/:code', loadChildren: () => import('../app/components/time-table-detail/time-table-detail.module').then(m => m.TimeTableDetailModule), canActivate: [NonAuthGuard] },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes),
    BrowserModule, HttpClientModule],
  exports: [RouterModule]
})
export class AppRoutingModule { }
